// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"89844e0e","90":"780ddce9"}[chunkId] + ".chunk.js";
};